import { generateUUID } from '@client/util';
import type { TToast } from './ToastContainer';

type ToastSubscriber = (toast: TToast) => void;

const subscribers = new Set<ToastSubscriber>();

export const ToastManager = {
    subscribe: (callback: ToastSubscriber): (() => void) => {
        subscribers.add(callback);
        return () => subscribers.delete(callback);
    },
    notify: (toast: TToast) => {
        subscribers.forEach(callback => callback(toast));
    },
};

export const showToast = (toast: Omit<TToast, 'id'>) => {
    ToastManager.notify({ id: generateUUID(), ...toast });
};
